export default {
  resource:{
    zh: {
      title:"人事",
      companyNo:"公司",
      companyName:"公司",
      empId:"工号",
      empNo:"工号",
      empName:"姓名",
      sex:"性别",
      sex1: "男",
      sex2: "女",
      status:"状态",
      status1: "在职",
      status2: "离职",
      deptNo:"部门",
      deptName:"部门",
      xgroup:"组别",
      duty:"职务",
      job:"岗位",
      jobTitle:"职称",
      shiftName:"班次",
      shiftNo:"班次",
      groupNo:"班组",
      groupName:"班组",
      shiftNo_B:"班次",
      shiftName_B:"班次",
      groupNo_B:"班组",
      groupName_B:"班组",
      planNo:"打卡方案",
      planName:"打卡方案",
      accessControlNo:"门禁方案",
      accessControlName:"门禁方案",
      icNo:"IC卡号",
      birthday:"生日",
      native:"籍贯",
      marriage:"婚否",
      homeplace:"家庭地址",
      education:"学历",
      education1:"博士",
      education2:"硕士",
      education3:"本科",
      education4:"专科",
      education5:"中专",
      education6:"高中",
      education7:"初中",
      education8:"其他",
      physicalDate:"体检日期",
      graduateSchool:"毕业院校",
      major:"专业",
      arriveDate:"报到日",
      arriveDate1:"报到日(开始)",
      arriveDate2:"报到日(结束)",
      contract:"合同",
      contractType:"合同类型",
      contractType1:"劳动合同",
      contractType2:"无固定期合同",
      contractType3:"返聘协议",
      contractNo:"合同编号",
      contractStartDate:"合同签订日",
      contractEndDate:"合同终止日",
      contractPeriod:"合同期(月)",
      bankAccount:"银行账号",
      bankName :"开户银行",

      political:"政治面貌",
      address:"证件地址",
      idCardNo:"证件号码",
      periodOfValidity:"证件有效期",
      residenceAddress:"户口所在地",
      nation:"民族",
      phone:"联系电话",
      consultantName:"紧急联系人",
      filiaction: "联系人关系",
      consultantPhone:"联系人电话",
      departureDate:"离职日",
      departureType:"离职类型",
      departureReason:"离职原因",
      isblack:"黑名单",
      socialSecurity:"社保",
      socialSecurity1: "已购买",
      socialSecurity0: "未购买",
      salaryType:"薪别",
      salaryMethod: "计薪方法",
      salaryBase:"基本工资",
      salaryPost:"职位薪贴",
      restDays: "工休天数",
      foodSubsidy:"伙食补贴",
      startAge:"入厂年龄",
      workMonth:"工龄(月)",
      age:"年龄",
      probationMonth:"试用期(月)",
      probationEndDate:"试用到期",
      stemFrom:"来源渠道",
      newOrReplace:"新增/替补",
      fingerStatus:"指纹状态",
      fingerStatus0:"未采集",
      fingerStatus1:"待上传",
      fingerStatus2:"已上传",
      faceStatus:"人脸模板状态",
      faceStatus0:"未采集",
      faceStatus1:"待下载",
      faceStatus2:"待上传",
      faceStatus3:"已上传",
      introducer:"介绍人",
      regCard:"IC卡登记",
      reg:"登记",
      

      lzr1: "离职日(开始)",
      lzr2: "离职日(结束)",
      gr: "个人资料",
      xz: "薪别资料",
      qt: "入职资料",
      hf1: "已婚",
      hf0: "未婚",
      hf2: "离异",
      hf3: "葬偶",
      xb1: "男",
      xb2: "女",
      jn1: "在职",
      jn2: "离职",
      dw1: "辞退",
      dw2: "合同到期",
      dw3: "即辞即走",
      dw4: "开除",
      dw5: "离职",
      dw6: "正常辞工",
      dw7: "自动离厂",
      dw8: "异动清远",
      dw9: "异动湖北",
      mcard: "打印厂牌",
      mcardp: "输入打印厂牌",
      readCard: "读取身份证信息",
      cFinger: "采集指纹",
      takePhoto: "拍照",
      retakePhoto: "重拍",
      submit: "确定",
      delFinger: "删除",
      reCFinger: "重新采集",
      attVerifyType:"打卡方式",
      attVerifyType1:"磁卡/指纹/人脸",
      attVerifyType2:"指纹/人脸",
      attVerifyType3:"磁卡",
      accVerifyType:"门禁方式",
      accVerifyType1:"磁卡/指纹/人脸",
      accVerifyType2:"指纹/人脸",
      accVerifyType3:"磁卡",
      iPrint:"输入打印",
      print:"打印",
      notFound:"工号不存在或员工已离职！",
      is_show:"B帐显示",
      shiftNoB:"B帐班次",
      groupNoB:"B帐班组",
      idExist: "部门序号或名称已经存在，请检查！",
      nameExist: "部门已经存在，请检查！",
      ybms: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛难族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "崩龙族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
        "其他",
        "外国血统"
      ],
      zws: [
        "普通员工",
        "高层管理",
        "管理人员",
        "办公室职员",
        "技术人员"
      ],
      byyxs: [
        "CNC学徒",
        "ISO专员",
        "QA",
        "QC",
        "班长",
        "搬运工",
        "保安员",
        "保洁员",
        "财务总监",
        "采购员",
        "仓管",
        "操作员",
        "厂长",
        "车工",
        "车间统计员",
        "出纳",
        "储备干部",
        "储备技术干",
        "吹膜",
        "吹膜切袋",
        "打料员",
        "大车司机",
        "代理领班",
        "电工",
        "电脑锣",
        "电脑维护员",
        "二维码专员",
        "发货员",
        "放货员",
        "分料员",
        "副主管",
        "副总经理",
        "跟单文员",
        "工程课长",
        "工业设计师",
        "会计员",
        "机修",
        "技术员",
        "加料员",
        "接货员",
        "经理",
        "空压机技术",
        "拉货",
        "料房",
        "料房领班",
        "领班",
        "模具补师",
        "配料员",
        "品管",
        "品检实验员",
        "品控专员",
        "人事文员",
        "设备督查员",
        "设备维护",
        "生产计划员",
        "生产经理",
        "省模",
        "师傅",
        "输单文员",
        "暑假工",
        "丝印师傅",
        "碎料员",
        "体系文员",
        "体系主管",
        "文员",
        "物控计划员",
        "物控主管",
        "物料员",
        "小车司机",
        "薪酬统计员",
        "薪资核算员",
        "学徒",
        "研发主任",
        "业务专员",
        "营业员",
        "员工",
        "杂工",
        "招聘专员",
        "主管",
        "助理",
        "助理技术员",
        "装模",
        "装配",
        "装卸工",
        "资料员",
        "自动吹瓶师",
        "组长"
      ]

    }
    

  },
  newId: "autoid",
  delConf: ["xm"],
  delKeys:["autoid"],
  params: {
    companyNo: {
      key: "companyNo",
      defaultIdx: 0,
      method: "Contains",
      type: "select",
      options: "company"
    },
    dept: {
      key: "deptNo",
      tkey: "deptNo",
      data: null,
      method: "Equal",
      type: "select",
      options: [{
        value: "",
        text: "All"
      }]
    },
    jn: {
      key: "status",
      data: "1",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }, {
        value: "1",
        text: "在职"
      }, {
        value: "2",
        text: "离职"
      }]
    },
    empId: {
      key: "empId",
      data: "",
      method: "Equal",
      type: "number"
    },
    empName: {
      key: "empName",
      data: "",
      method: "Contains",
      type: "text"
    },
    arriveDate: {
      key: "arriveDate",
      tkey: "arriveDate1",
      data: "",
      method: "GreaterThanOrEqual",
      type: "date",
      more: true
    },
    arriveDate2: {
      key: "arriveDate",
      tkey: "arriveDate2",
      data: "",
      method: "LessThanOrEqual",
      type: "date",
      more: true
    },
    lzr1: {
      key: "departureDate",
      tkey: "lzr1",
      data: "",
      method: "GreaterThanOrEqual",
      type: "date",
      more: true
    },
    lzr2: {
      key: "departureDate",
      tkey: "lzr2",
      data: "",
      method: "LessThanOrEqual",
      type: "date",
      more: true
    },
    native: {
      key: "native",
      data: "",
      method: "Contains",
      type: "text",
      more: true
    },
    birthday: {
      key: "birthday",
      data: "",
      method: "Equal",
      type: "date",
      more: true
    },
    shiftNo: {
      key: "shiftNo",
      data: "",
      method: "Equal",
      type: "text",
      more: true
    },
    sex: {
      key: "sex",
      data: "",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }, {
        value: "1",
        text: "男"
      }, {
        value: "2",
        text: "女"
      }]
    },
    marriage: {
      key: "marriage",
      data: "",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }, {
        value: "1",
        text: "已婚"
      }, {
        value: "0",
        text: "未婚"
      }, {
        value: "2",
        text: "离异"
      }, {
        value: "3",
        text: "葬偶"
      }]
    }
  },
  listDefine: [
    "companyName",
"empId",
"empNo",
"empName",
{key:"sex", formatter:"fsex"},
"deptName",
"xgroup",
"duty",
"job",
"jobTitle",
"shiftName",
"groupName",
"planName",
{key:"attVerifyType", formatter:"fattVerifyType"},
"accessControlName",
{key:"accVerifyType", formatter:"faccVerifyType"},
"icNo",
{key:"fingerStatus", formatter:"ffingerStatus"},
{key:"faceStatus", formatter:"ffaceStatus"},
{key:"contractStartDate", formatter:"fdate"},
{key:"contractEndDate", formatter:"fdate"},
{key:"arriveDate", formatter:"fdate"},
"probationMonth",
{key:"probationEndDate", formatter:"fdate"},
"stemFrom",
"newOrReplace",
{key:"socialSecurity", formatter:"fsocialSecurity"},
"startAge",
"workMonth",
"age",
{key:"status", formatter:"fstatus"},
{key:"departureDate", formatter:"fdate"},
"departureType",
"departureReason",
"isblack",
"idCardNo",
"address",
"birthday",
"phone"
  ],
  isShowMore: true,
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "empId",
  defaultSortOrder: "desc",
  sortName: "empId",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "employee/",
  formatter: {
    ffingerStatus(t) {
      return 'fingerStatus' + t
    },
    ffaceStatus(v) {
      return "faceStatus" + v
    },
    fsex(t) {
      return 'sex' + t
    },
    fstatus(t) {
      return 'status' + t
    },
    fsocialSecurity(v) {
      if (v==1) return "socialSecurity" + v
      return "socialSecurity0"
    },
    fattVerifyType(v){
      if (v) return "attVerifyType"+ v
    },
    faccVerifyType(v){
      if (v) return "accVerifyType"+ v
    }
  }

}
